import Vue from 'vue'
import Vuex from 'vuex'
import './../calculators'
import calculator from 'apps/bankrate-calculators/savings/saving-goals-calculator'

Vue.use(Vuex)

new Vue({
  el: '#calculator',
  components: { calculator }
})
